import Modals from "components/Modal";
import { ONE_OFF_ANALYTICS } from "navigation/routes";
import { Link } from "react-router-dom";
import { startCase } from 'lodash'
import useOneOffReportCampaign from "hook/reports/useOneOffReportCampaign";
import ButtonWithTips from "components/ButtonWithTips";
import MembershipEnhancedTable from "components/MembershipEnhancedTable";
import { formatMoney } from "utils/functions";
import zipcelx from "zipcelx";
import { format } from "date-fns";

const OneOffReportC = () => {
  const { currentData, setCurrentData, open, setOpen, updateMyData, skipPageReset, columns, data,
    setSearch, page, setPage,
    setFrom, setTo, dataOneOff, totalAmount,
    setData, current, edit, setEdit } = useOneOffReportCampaign()

  const rows = dataOneOff?.data?.data?.fund_raising?.data || [];

  function getExcel() {
    if (!rows.length) return;
    const headers = [
      { value: 'Date', type: 'string' },
      { value: 'Name', type: 'string' },
      { value: 'Phone Number', type: 'string' },
      { value: 'Campaign Type', type: 'string' },
      { value: 'Cycle', type: 'string' },
      { value: 'Amount', type: 'number' },
    ];
    const dataRows = rows.map(row => [
      { value: row?.created_at ? format(new Date(row.created_at), 'MMM dd yyyy') : '-', type: 'string' },
      { value: `${row?.user?.first_name || ''} ${row?.user?.last_name || ''}`.trim() || '-', type: 'string' },
      { value: row?.user?.phone_mobile || '-', type: 'string' },
      { value: row?.fund_raising?.name || '-', type: 'string' },
      { value: row?.donation_cycle || '-', type: 'string' },
      { value: parseFloat(row?.transaction?.amount || 0), type: 'number' },
    ]);
    const summationRow = [
      { value: '', type: 'string' }, { value: '', type: 'string' }, { value: '', type: 'string' },
      { value: '', type: 'string' }, { value: 'Total Amount', type: 'string' },
      { value: totalAmount, type: 'number' },
    ];
    zipcelx({ filename: 'One_Off_Campaign_Report', sheet: { data: [headers, ...dataRows, summationRow] } });
  }

   
  return (
    <>
      <div className="container-fluid px-4">
        <div className="d-sm-flex align-items-start justify-content-between mt-4">
          <div>
            <h1>One Off Campaign Report</h1>
            <ol className="breadcrumb mb-2">
              <li className="breadcrumb-item">One Off Campaign Donations</li>
              <li className="breadcrumb-item active">All</li>
            </ol>
          </div>
          <Link className="btn btn-primary mb-2" to={`../${ONE_OFF_ANALYTICS}`} relative="path">View Analytics</Link>
        </div>
        <div className="card mb-4">
          <div className="card-header">
            <i className="fas fa-table me-1"></i>
            One Off Campaign Donations
          </div>
          <div className="row">
          <div className="col-3">
              <input type='text' placeholder='Global Search Record' className="form-control" 
              onChange={(e) => {
                var ds=dataOneOff
                setSearch(e.target.value);
              }}
              />
            </div>
         
            <div className="col-3"> 
            <div className="filterParameters" id="filterParameters">
        <div className="datePickerWrapper">
          <div className="d-sm-flex align-items-end gap-2">
            <div className="form-inline">From:
              <input type='date' className="form-control" onChange={(e) => {
                setFrom(e.target.value);
              }}  />
            </div>
            <div className="form-inline">To:
              <input type='date' className="form-control" onChange={(e) => {
                setTo(e.target.value);
              }}/>
            </div>
            <ButtonWithTips
                id="getExcel"
                tips="Click to download data in excel format"
                btnProps={{
                  className: 'btn btn-success',
                  onClick: getExcel,
                }}
              >
                <i className="fas fa-file-excel"></i>
              </ButtonWithTips>
          </div>

        </div>
      </div>
            </div>
          </div> 
          <div className="card-body">
          <div className="alert alert-info d-inline-block py-2 px-3 mb-3">
            <strong>Total Amount:</strong> {formatMoney(totalAmount)}
          </div>
          <MembershipEnhancedTable
              columns={columns}
              data={rows}
              setData={setData}
              skipPageReset={skipPageReset} 
              lastPage={dataOneOff?.data?.data?.fund_raising?.last_page}
              currentPage={dataOneOff?.data?.data?.fund_raising?.current_page}
              setCurrentPage={setPage}
               isFetching={data!==undefined}
            />
            {/* <TableTwo
              columns={columns}
              data={data || []}
              setData={setData}
              pagesize={100}
              skipPageReset={skipPageReset}
              filterTable={data?.length}
              isLoading={isLoading}
              fileName='one-off-campaign-reports'
            /> */}
          </div>
        </div>
      </div>
      <Modals show={open && current === 'view'}
        onHide={() => setOpen(false)} title='View Donation' size='md'>
        <dl className="striped">
          {currentData && Object.entries(currentData)?.map(([key, value]) =>
            typeof value !== 'string' && typeof value !== 'number' ? [] : <div key={key} className='row'>
              <dt className='col-4'>{`${startCase(key)} :`}</dt>
              {(!edit || key === 'id') && <dd className='col-8'>{value}</dd>}
              {edit && key !== 'id' && <div className="col-8"><input className="form-control" type="text" defaultValue={value} onChange={(e) => setCurrentData({ ...currentData, [key]: e.target.value })} /></div>}
            </div>)}
        </dl>
      </Modals>
    </>
  )
}

export default OneOffReportC
